module.exports = __webpack_public_path__ + "media/images/safety-men-hivis-682cebf5bc6d13cbc3ba43743af3fe01.png";